import { en } from '@nuxt/ui/locale';

/**
 * Maps an app i18n locale code (region-hyphenated, e.g. `en-US`) to the
 * matching Nuxt UI bundled locale. Add an entry here when adding an app locale;
 * unmapped codes fall back to English.
 */
const NUXT_UI_LOCALE_BY_APP_CODE = {
	'en-US': en,
} as const;

const DEFAULT_NUXT_UI_LOCALE = en;

export function resolveNuxtUiLocale(appLocaleCode: string) {
	return NUXT_UI_LOCALE_BY_APP_CODE[appLocaleCode as keyof typeof NUXT_UI_LOCALE_BY_APP_CODE]
		?? DEFAULT_NUXT_UI_LOCALE;
}

type NuxtUiMessageOverrides = {
	[Namespace in keyof typeof en.messages]?: Partial<(typeof en.messages)[Namespace]>;
};

/**
 * Builds the app-controlled override subtree merged over the Nuxt UI base
 * locale. Only seed keys for Nuxt UI primitives the app actually renders
 * (selectMenu via DSelectMenu, inputNumber via DInputNumber). Param-free keys
 * only — tokenized keys (e.g. fileUpload.removeFile `{filename}`) require
 * raw-message reads; see the nuxt-ui-i18n-bridge learning doc.
 */
export function buildNuxtUiOverrides(t: (key: string) => string): NuxtUiMessageOverrides {
	return {
		selectMenu: {
			search: t('nuxt_ui.select_menu.search'),
			noMatch: t('nuxt_ui.select_menu.no_match'),
		},
		inputNumber: {
			increment: t('nuxt_ui.input_number.increment'),
			decrement: t('nuxt_ui.input_number.decrement'),
		},
	};
}
